import * as IndicatorsActions from './indicators.actions';
import type { IndicatorsState } from '@protector/entities/indicator/__legacy__/redux.types';

const { IndicatorsActionsTypes } = IndicatorsActions;

type IndicatorsActionsFunctions = Omit<typeof IndicatorsActions, 'IndicatorsActionsTypes'>;
type ActionsResponses = ReturnType<IndicatorsActionsFunctions[keyof IndicatorsActionsFunctions]>;

const initialState: IndicatorsState = {
  isLoading: false,
  error: null,
  indicators: {},
  windows: {}
};

export default (state = initialState, action: ActionsResponses) => {
  switch (action.type) {
    case IndicatorsActionsTypes.LOAD_DAYS_INDICATORS:
      return {
        ...state,
        isLoading: true
      };
    case IndicatorsActionsTypes.LOAD_DAYS_INDICATORS_SUCCESS:
      return {
        ...state,
        indicators: { ...state.indicators, [action.payload.propertyId]: action.payload.indicator },
        isLoading: false,
        error: null
      };
    case IndicatorsActionsTypes.LOAD_DAYS_INDICATORS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };

    case IndicatorsActionsTypes.LOAD_WINDOW_INDICATOR:
      return {
        ...state,
        isLoading: true
      };
    case IndicatorsActionsTypes.LOAD_WINDOW_INDICATOR_SUCCESS:
      return {
        ...state,
        windows: {
          ...state.windows,
          [action.payload.propertyId]: { ...state.windows[action.payload.propertyId], [action.payload.areaId]: action.payload.window }
        },
        isLoading: false,
        error: null
      };
    case IndicatorsActionsTypes.LOAD_WINDOW_INDICATOR_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    default:
      return state;
  }
};
